import { IconProps } from 'icons/Credits.icon';
import React from 'react';

const UserEditIcon: React.FC<IconProps> = ({ color = '#020511' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 15H7C5.93913 15 4.92172 15.4214 4.17157 16.1716C3.42143 16.9217 3 17.9391 3 19V21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.377 16.626C21.7754 16.2276 21.9991 15.6874 21.9991 15.124C21.9991 14.5606 21.7754 14.0204 21.377 13.622C20.9786 13.2236 20.4384 12.9999 19.875 12.9999C19.3116 12.9999 18.7714 13.2236 18.373 13.622L14.363 17.634C14.1252 17.8716 13.9512 18.1653 13.857 18.488L13.02 21.358C12.9949 21.444 12.9934 21.5353 13.0156 21.6221C13.0379 21.7089 13.0831 21.7882 13.1464 21.8516C13.2098 21.9149 13.2891 21.9601 13.3759 21.9824C13.4627 22.0046 13.554 22.0031 13.64 21.978L16.51 21.141C16.8327 21.0468 17.1264 20.8728 17.364 20.635L21.377 16.626Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserEditIcon;
